import { Route } from 'vue-router';
import { store } from '@/store';
import { getModule } from 'vuex-module-decorators';
import LoanStore from '@/loan/store';

const loanStore = getModule(LoanStore, store);

export const loanAutopayRoutePropHandler = (route: Route) => {
	const { amount } = route.query;

	if (amount !== undefined) {
		return {
			amount: Number.isNaN(Number(amount)) ? 0 : Number(amount),
		};
	}

	const { loanDetails } = loanStore;
	const autopayMinimum = loanDetails?.recurringPayment.minimum ?? 0;

	return {
		amount: Number(autopayMinimum),
	};
};
